import {
  defaultInitialState,
  // defaultFetchRequestState,
  // defaultFetchReceiveSuccessState,
  // defaultFetchReceiveErrorState,
} from "shared/redux-store/defaultAppReducerParts";

// TODO refactor to new architcture and test
export default function startupsDashboardAppReducer(
  state = defaultInitialState(),
  action,
) {
  switch (action.type) {
    // case "FETCH_STARTUPS_DASHBOARD_PENDING":
    //   return {
    //     ...state,
    //     ...defaultFetchRequestState(state, action),
    //   }
    // case "FETCH_STARTUPS_DASHBOARD_FULFILLED":
    case "FETCH_PRODUCT_LINES":
      return {
        ...state,
        // ...defaultFetchReceiveSuccessState(state, action, resourceNames),
        isFetching: false,
      };
    // case "FETCH_STARTUPS_DASHBOARD_REJECTED":
    //   return {
    //     ...state,
    //     ...defaultFetchReceiveErrorState(state, action),
    //   }
    default:
      return state;
  }
}
